module.exports = __webpack_public_path__ + "static/OneDotCd-Bold.61aaae2a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-Bold.woff2
// module id = 740
// module chunks = 114276838955818